/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "colors_default": "",
  "size_default": "prose-sm sm:prose-lg",
  "variant_default": "[&_ol]:list-decimal [&_ul]:list-disc [&>.font-weight-bold]:font-bold [&>.strikethrough]:line-through [&>.font-weight-black]:font-black [&>.font-weight-normal]:font-normal"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Prose");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;